module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.9942588a.ttf";